import React, { useState } from "react";
import { Box } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { EmblaCarouselType } from "embla-carousel";
import { useTranslation } from "next-i18next";
import { IconCaret } from "src/components/icons-mui/caret";

interface IHeroModuleNavProps {
    embla: EmblaCarouselType;
    autoplayInstance: { play: () => void; stop: () => void };
}

export const HeroSliderNav = ({ embla, autoplayInstance }: IHeroModuleNavProps) => {
    const { t } = useTranslation("common");
    const [selectedIndex, setSelectedIndex] = useState(embla.selectedScrollSnap() || 0);
    const slidesCount = embla.slideNodes().length || 0;

    React.useEffect(() => {
        if (!embla) {
            return;
        }
        const onSelect = () => setSelectedIndex(embla.selectedScrollSnap());
        embla.on("select", onSelect);
        onSelect();
        return () => {
            embla.off("select", onSelect);
        };
    }, [embla]);

    if (slidesCount <= 1) {
        return null;
    }

    const onPrevClick = () => {
        autoplayInstance?.stop();
        embla && embla.scrollPrev();
    };

    const onNextClick = () => {
        autoplayInstance?.stop();
        embla && embla.scrollNext();
    };

    return (
        <Box
            display="flex"
            alignItems="center"
            padding={1}
            gap={1}
            borderRadius="100px"
            position="absolute"
            bottom={["40px", "32px", "32px", "48px"]}
            left="50%"
            sx={{ transform: "translateX(-50%)", backgroundColor: "rgba(51, 51, 51, 0.8)" }}
        >
            <IconButton variant="round" size="extraSmall" onClick={onPrevClick} aria-label={t("back")} sx={{ display: ["none", "inline-flex"] }}>
                <IconCaret sx={{ transform: "rotate(90deg)" }} width="20px" height="20px" />
            </IconButton>
            {Array.from({ length: slidesCount }).map((_, i) => (
                <Box key={i} width="8px" height="8px" bgcolor={selectedIndex === i ? "green.500" : "white"} borderRadius="100%" />
            ))}
            <IconButton variant="round" size="extraSmall" onClick={onNextClick} aria-label={t("next")} sx={{ display: ["none", "inline-flex"] }}>
                <IconCaret sx={{ transform: "rotate(-90deg)" }} width="20px" height="20px" />
            </IconButton>
        </Box>
    );
};
